(function () {
  'use strict';

  var HOLD_MS = 10 * 60 * 1000;
  var STORAGE_KEY = 'arthcart_cart_hold_until';
  var enhanceTimer = null;
  var openTimer = null;
  var refreshInFlight = false;
  var lastRefreshAt = 0;
  var timerId = null;

  function sidebar() {
    return document.getElementById('halo-cart-sidebar');
  }

  function wrapEl() {
    return document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
  }

  function ensureHoldDeadline() {
    var until = parseInt(sessionStorage.getItem(STORAGE_KEY) || '0', 10);
    var now = Date.now();
    if (!until || until <= now) {
      until = now + HOLD_MS;
      sessionStorage.setItem(STORAGE_KEY, String(until));
    }
    return until;
  }

  function resetHoldDeadline() {
    sessionStorage.setItem(STORAGE_KEY, String(Date.now() + HOLD_MS));
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function tickTimer() {
    if (!document.body.classList.contains('cart-sidebar-show')) return;
    var root = sidebar();
    if (!root) return;
    var mmEl = root.querySelector('[data-arthcart-timer-mm]');
    var ssEl = root.querySelector('[data-arthcart-timer-ss]');
    if (!mmEl || !ssEl) return;

    var until = ensureHoldDeadline();
    var left = Math.max(0, until - Date.now());
    if (left === 0) {
      resetHoldDeadline();
      left = HOLD_MS;
    }
    var totalSec = Math.floor(left / 1000);
    mmEl.textContent = pad(Math.floor(totalSec / 60));
    ssEl.textContent = pad(totalSec % 60);
  }

  function startTimer() {
    if (timerId) return;
    tickTimer();
    timerId = setInterval(tickTimer, 1000);
  }

  function stopTimer() {
    if (!timerId) return;
    clearInterval(timerId);
    timerId = null;
  }

  function moneyFromCents(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        var format = (window.theme && theme.moneyFormat) || '{{amount}}';
        return Shopify.formatMoney(cents, format);
      }
    } catch (e) {}
    return '₹ ' + (Math.abs(cents) / 100).toFixed(2);
  }

  var OIL_HANDLE = 'arth-hanuman-blessed-pain-relief-oil';

  function oilCartImage() {
    var side = sidebar();
    return (side && side.getAttribute('data-oil-cart-image')) || '';
  }

  function fillMissingCartImages(root) {
    root.querySelectorAll('.previewCartItem').forEach(function (row) {
      var link = row.querySelector('.previewCartItem-image');
      if (!link) return;
      var img = link.querySelector('img');
      var fallback = link.getAttribute('data-fallback-image') || '';
      var handle = row.getAttribute('data-product-handle') || '';
      if (!fallback && handle === OIL_HANDLE) fallback = oilCartImage();
      if (!fallback) return;
      if (!img) {
        img = document.createElement('img');
        img.alt = '';
        img.loading = 'lazy';
        img.width = 110;
        img.height = 110;
        link.appendChild(img);
      }
      var src = img.getAttribute('src') || '';
      var looksMissing =
        !src ||
        src.indexOf('no-image') !== -1 ||
        src.indexOf('no_image') !== -1;
      if (looksMissing) {
        img.src = fallback;
        img.srcset = fallback;
      }
      img.addEventListener(
        'error',
        function () {
          if (img.getAttribute('src') !== fallback) {
            img.src = fallback;
            img.srcset = fallback;
          }
        },
        { once: true }
      );
    });
  }

  function enhanceLineItems(root) {
    fillMissingCartImages(root);
    root.querySelectorAll('.previewCartItem').forEach(function (row) {
      if (row.dataset.arthcartItemEnhanced === '1') return;
      var priceWrap = row.querySelector('.previewCartItem-price');
      row.dataset.arthcartItemEnhanced = '1';
      if (!priceWrap) return;

      var compareAt = parseInt(priceWrap.getAttribute('data-compare-at') || '0', 10);
      var original = parseInt(priceWrap.getAttribute('data-original-price') || '0', 10);
      var current = parseInt(
        priceWrap.getAttribute('data-final-price') || priceWrap.getAttribute('data-price') || '0',
        10
      );
      var was = Math.max(compareAt || 0, original || 0);
      if (was > current && current > 0 && !priceWrap.querySelector('.arthcart-cart-off')) {
        var pct = Math.round(((was - current) / was) * 100);
        if (pct > 0) {
          var off = document.createElement('span');
          off.className = 'arthcart-cart-off';
          off.textContent = '(' + pct + '% OFF)';
          var target =
            priceWrap.querySelector('.discounted-price') ||
            priceWrap.querySelector('[data-item-final-price-display]') ||
            priceWrap;
          target.appendChild(document.createTextNode(' '));
          target.appendChild(off);
        }
      }
    });
  }

  function updateSavedBadge(root) {
    var badge = root.querySelector('[data-arthcart-cart-saved]');
    var amountEl = root.querySelector('[data-arthcart-cart-saved-amount]');
    if (!badge || !amountEl) return;

    var saved = parseInt(badge.getAttribute('data-saved-cents') || '0', 10);
    if (saved <= 0) {
      root.querySelectorAll('.previewCartItem-price').forEach(function (priceWrap) {
        var compareAt = parseInt(priceWrap.getAttribute('data-compare-at') || '0', 10);
        var original = parseInt(priceWrap.getAttribute('data-original-price') || '0', 10);
        var current = parseInt(
          priceWrap.getAttribute('data-final-price') || priceWrap.getAttribute('data-price') || '0',
          10
        );
        var qty = parseInt(priceWrap.getAttribute('data-line-qty') || '1', 10) || 1;
        var was = Math.max(compareAt || 0, original || 0, current || 0);
        if (was > current) saved += (was - current) * qty;
      });
    }

    var nextText = moneyFromCents(saved);
    var nextHidden = saved <= 0;
    if (amountEl.textContent !== nextText) amountEl.textContent = nextText;
    if (badge.hidden !== nextHidden) badge.hidden = nextHidden;
  }

  function bindUpsellAdd(root) {
    root.querySelectorAll('.previewCartCarousel .arthcart-cart-upsell-add, .previewCartCarousel .card-button').forEach(function (details) {
      if (details.dataset.arthcartUpsellClick === '1') return;
      var variantId = details.getAttribute('data-arthcart-upsell-variant') || '';
      details.dataset.arthcartUpsellClick = '1';
      details.classList.add('arthcart-cart-upsell-add');
      details.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        addUpsell(details, variantId);
      });
    });
  }

  function addUpsell(btn, variantId) {
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    var prev = btn.textContent || '+ Add';
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        resetHoldDeadline();
        btn.textContent = 'Added';
        openCartDrawer({ celebrate: true });
        setTimeout(function () {
          btn.textContent = '+ Add';
          btn.disabled = false;
        }, 700);
      })
      .catch(function () {
        btn.textContent = prev;
        btn.disabled = false;
      });
  }

  var GAUSEVA_KEY = 'arthcart_gauseva_pct';

  function moneyINR(cents) {
    return moneyFromCents(cents);
  }

  function persistGauseva(pct, amountCents) {
    try {
      localStorage.setItem(GAUSEVA_KEY, String(pct));
    } catch (e) {}
    var rupees = (Math.max(0, amountCents) / 100).toFixed(2);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: {
          gauseva_percent: String(pct),
          gauseva_amount: pct > 0 ? '₹' + rupees : 'None',
          'Gauseva Contribution': pct > 0 ? pct + '% (₹' + rupees + ')' : 'None'
        }
      })
    }).catch(function () {});
  }

  function bindGauseva(root) {
    var box = root.querySelector('[data-arthcart-gauseva]');
    if (!box || box.dataset.bound === '1') return;
    box.dataset.bound = '1';

    var cartTotal = parseInt(box.getAttribute('data-cart-total') || '0', 10) || 0;
    var opts = box.querySelectorAll('[data-gauseva-pct]');
    var customInput = box.querySelector('[data-gauseva-custom]');
    var addBtn = box.querySelector('[data-gauseva-add]');
    var line = root.querySelector('[data-arthcart-gauseva-line]');
    var lineAmt = root.querySelector('[data-arthcart-gauseva-line-amt]');
    var totalNow = root.querySelector('[data-arthcart-total-now]');

    function amountForPct(pct) {
      return Math.round((cartTotal * pct) / 100);
    }

    opts.forEach(function (btn) {
      var pct = parseInt(btn.getAttribute('data-gauseva-pct') || '0', 10);
      var amtEl = btn.querySelector('[data-gauseva-amt]');
      if (amtEl && pct > 0) amtEl.textContent = moneyINR(amountForPct(pct));
    });

    function applySelection(pct, customCents) {
      var hasCustom = typeof customCents === 'number';
      var cents = hasCustom ? customCents : amountForPct(pct);
      opts.forEach(function (btn) {
        var p = parseInt(btn.getAttribute('data-gauseva-pct') || '0', 10);
        btn.classList.toggle('is-active', !hasCustom && p === pct);
      });
      if (hasCustom) {
        opts.forEach(function (btn) { btn.classList.remove('is-active'); });
      }
      /* None (0) is valid — hide line + do not add to Estimated Total.
         display:none beats #halo-cart-sidebar .previewCartTotals { display:flex }. */
      var isNone = !hasCustom && pct === 0;
      if (isNone || cents <= 0) {
        if (line) {
          line.hidden = true;
          line.style.display = 'none';
        }
        if (lineAmt) lineAmt.textContent = '';
        if (totalNow) totalNow.textContent = moneyINR(cartTotal);
      } else {
        if (line) {
          line.hidden = false;
          line.style.display = '';
        }
        if (lineAmt) lineAmt.textContent = moneyINR(cents);
        if (totalNow) totalNow.textContent = moneyINR(cartTotal + Math.max(0, cents));
      }
      persistGauseva(hasCustom ? -1 : pct, cents);
    }

    var savedPct = 5;
    try {
      /* "0" is truthy — None must not fall through to default 5 */
      var stored = parseInt(localStorage.getItem(GAUSEVA_KEY) || box.getAttribute('data-attr-pct') || '5', 10);
      if (Number.isFinite(stored)) savedPct = stored;
    } catch (e2) {}
    if (savedPct < 0) savedPct = 5;
    applySelection(savedPct);

    opts.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pct = parseInt(btn.getAttribute('data-gauseva-pct') || '0', 10);
        if (customInput) customInput.value = '';
        applySelection(pct);
      });
    });

    box.querySelectorAll('[data-gauseva-step]').forEach(function (stepBtn) {
      stepBtn.addEventListener('click', function () {
        if (!customInput) return;
        var step = parseInt(stepBtn.getAttribute('data-gauseva-step') || '0', 10);
        var cur = parseFloat(customInput.value || '0') || 0;
        customInput.value = String(Math.max(0, Math.round(cur + step)));
      });
    });

    if (addBtn && customInput) {
      addBtn.addEventListener('click', function () {
        var rupees = parseFloat(customInput.value || '0') || 0;
        applySelection(0, Math.round(rupees * 100));
      });
    }
  }

  function patchMobileQuickshop() {
    if (!window.halo || typeof window.halo.appendProductQuickShopOption2 !== 'function') return false;
    if (window.halo.__arthcartQuickPatched) return true;
    window.halo.__arthcartQuickPatched = true;
    var original = window.halo.appendProductQuickShopOption2.bind(window.halo);
    window.halo.appendProductQuickShopOption2 = function (product) {
      try {
        var $p = window.jQuery ? window.jQuery(product) : null;
        if ($p && $p.length) {
          var variantPopup = $p.find('.variants-popup');
          variantPopup.find('.selector-wrapper').each(function () {
            var $el = window.jQuery(this);
            $el.find('.swatch-element:not(.soldout):not(.unavailable)').eq(0).find('.single-label').trigger('click');
          });
          var $btn = $p.find('[data-quickshop-popup]').first();
          if (typeof window.halo.initAddToCartQuickShop === 'function' && $btn.length) {
            window.halo.initAddToCartQuickShop($btn, variantPopup);
            document.body.classList.remove('quick_shop_popup_mobile');
            var popup = document.getElementById('halo-card-mobile-popup');
            if (popup) popup.classList.remove('show');
            $p.removeClass('quickshop-popup-show');
            setTimeout(function () {
              openCartDrawer({ celebrate: true });
            }, 350);
            return;
          }
        }
      } catch (err) {}
      return original(product);
    };
    return true;
  }

  function enhanceCart(root) {
    if (!root) return;
    root.classList.add('arthcart-cart-drawer');
    syncCartCountLabel(root);
    enhanceLineItems(root);
    updateSavedBadge(root);
    bindUpsellAdd(root);
    bindGauseva(root);
    tickTimer();
  }

  function syncCartCountLabel(root) {
    var wrap = root.querySelector('.wrapper-cartCount');
    if (!wrap) return;
    var countEl = wrap.querySelector('[data-cart-count]');
    if (!countEl) return;
    var n = parseInt((countEl.textContent || '').replace(/\D/g, ''), 10);
    if (isNaN(n)) n = 0;
    wrap.innerHTML =
      '<span aria-hidden="true">(</span><span class="cartCount" data-cart-count>' +
      n +
      '</span> <span data-arthcart-cart-count-label">' +
      (n === 1 ? 'item' : 'items') +
      '</span><span aria-hidden="true">)</span>';
  }

  function scheduleEnhance() {
    if (enhanceTimer) clearTimeout(enhanceTimer);
    enhanceTimer = setTimeout(function () {
      enhanceTimer = null;
      enhanceCart(sidebar());
    }, 80);
  }

  function htmlLooksLikeSideCart(html) {
    if (!html || html.length < 40) return false;
    if (/<!DOCTYPE|<html[\s>]/i.test(html)) return false;
    return html.indexOf('previewCart') !== -1;
  }

  function refreshSidebarHtml(force) {
    var wrap = wrapEl();
    if (!wrap) return Promise.resolve(false);
    var now = Date.now();
    if (!force && (refreshInFlight || now - lastRefreshAt < 600)) {
      return Promise.resolve(false);
    }
    if (refreshInFlight && !force) return Promise.resolve(false);
    refreshInFlight = true;
    lastRefreshAt = now;
    var rootPath = (window.routes && window.routes.root) || '';
    return fetch(rootPath + '/cart?view=ajax_side_cart', {
      cache: 'no-store',
      headers: { Accept: 'text/html' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('side cart ' + r.status);
        return r.text();
      })
      .then(function (html) {
        if (!htmlLooksLikeSideCart(html)) return false;
        wrap.innerHTML = html;
        scheduleEnhance();
        return true;
      })
      .catch(function () {
        return false;
      })
      .then(function (ok) {
        refreshInFlight = false;
        return ok;
      });
  }

  var pendingCelebrate = false;

  function fireCartConfetti() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var root = sidebar();
    if (!root) return;
    var existing = document.getElementById('arthcart-cart-confetti');
    if (existing) existing.remove();

    var canvas = document.createElement('canvas');
    canvas.id = 'arthcart-cart-confetti';
    canvas.className = 'arthcart-cart-confetti';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    var rect = root.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.max(280, Math.floor(rect.width || 360));
    var h = Math.max(420, Math.floor(window.innerHeight || 600));
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';
    canvas.style.top = '0px';
    canvas.style.right = '0px';

    var ctx = canvas.getContext('2d');
    if (!ctx) {
      canvas.remove();
      return;
    }
    ctx.scale(dpr, dpr);

    var colors = ['#3b6400', '#ffd400', '#e8f0dc', '#111111', '#7cbc3d', '#ffffff', '#f4c430'];
    var parts = [];
    var originX = w * 0.5;
    var originY = 24;
    for (var i = 0; i < 90; i++) {
      var angle = (Math.PI * 0.15) + Math.random() * Math.PI * 0.7;
      var speed = 4 + Math.random() * 7;
      parts.push({
        x: originX + (Math.random() - 0.5) * 40,
        y: originY,
        vx: Math.cos(angle) * speed * (Math.random() > 0.5 ? 1 : -1) * (0.35 + Math.random()),
        vy: Math.sin(angle) * speed + 2,
        g: 0.14 + Math.random() * 0.08,
        w: 5 + Math.random() * 6,
        h: 7 + Math.random() * 8,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.35,
        color: colors[i % colors.length],
        life: 0,
        max: 70 + Math.floor(Math.random() * 30)
      });
    }

    var frame = 0;
    function draw() {
      frame += 1;
      ctx.clearRect(0, 0, w, h);
      var alive = 0;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.life += 1;
        if (p.life > p.max) continue;
        alive += 1;
        p.vy += p.g;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        var alpha = 1 - p.life / p.max;
        ctx.save();
        ctx.globalAlpha = Math.max(0, alpha);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }
      if (alive > 0 && frame < 140) {
        requestAnimationFrame(draw);
      } else {
        canvas.remove();
      }
    }
    requestAnimationFrame(draw);
  }

  function doOpenCartDrawer() {
    ensureHoldDeadline();
    document.body.classList.add('cart-sidebar-show');
    startTimer();
    if (pendingCelebrate) {
      pendingCelebrate = false;
      setTimeout(fireCartConfetti, 120);
    }
    // Always refresh cart HTML on open — skipping caused empty/stale drawer after ATC
    scheduleEnhance();
    refreshSidebarHtml(true);
  }

  function closeCartDrawer() {
    document.body.classList.remove('cart-sidebar-show');
    stopTimer();
    try {
      if (window.jQuery) window.jQuery('body').removeClass('cart-sidebar-show');
    } catch (e) {}
  }

  function openCartDrawer(opts) {
    if (opts && opts.celebrate) pendingCelebrate = true;
    if (openTimer) clearTimeout(openTimer);
    openTimer = setTimeout(function () {
      openTimer = null;
      doOpenCartDrawer();
    }, 40);
  }

  window.arthcartOpenCartDrawer = function () {
    openCartDrawer({ celebrate: true });
  };
  window.arthcartCloseCartDrawer = closeCartDrawer;

  function pathLooksThankYou(path) {
    path = (path || location.pathname || '').toLowerCase();
    return (
      path.indexOf('thank_you') !== -1 ||
      path.indexOf('/thank-you') !== -1 ||
      path.indexOf('/orders') !== -1
    );
  }

  function consumeOpenCartIntent() {
    var shouldOpen = false;
    try {
      if (sessionStorage.getItem('arthcart_open_cart') === '1') {
        sessionStorage.removeItem('arthcart_open_cart');
        shouldOpen = true;
      }
    } catch (e) {}
    try {
      var params = new URLSearchParams(location.search);
      if (params.get('open_cart') === '1' || params.get('cart') === 'open') {
        shouldOpen = true;
        params.delete('open_cart');
        params.delete('cart');
        var qs = params.toString();
        history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
      }
    } catch (e2) {}
    if (shouldOpen) openCartDrawer();
  }

  function markFromCheckout() {
    try {
      sessionStorage.setItem('arthcart_from_checkout', String(Date.now()));
    } catch (e) {}
  }

  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return false;
    if (el.closest('a[href*="/checkout"]')) return true;
    if (el.closest('#cart-sidebar-checkout, .button-checkout')) return true;
    if (el.closest('.rzp-magic-btn__buy-product, .rzp-magic-btn, magic-checkout-btn')) {
      return true;
    }
    return false;
  }

  function isSameOriginCartPageLink(link) {
    if (!link) return false;
    if (link.id === 'cart-sidebar-checkout') return false;
    if (link.classList && link.classList.contains('button-checkout')) return false;
    var href = link.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return false;
    var url;
    try {
      url = new URL(href, location.href);
    } catch (e) {
      return false;
    }
    if (url.origin !== location.origin) return false;
    var path = ((url.pathname || '').replace(/\/+$/, '') || '/').toLowerCase();
    if (path.indexOf('/checkout') !== -1) return false;
    if (url.searchParams.has('view')) return false;
    if (path !== '/cart' && path.slice(-5) !== '/cart') return false;
    return true;
  }

  function checkoutOverlayOpen() {
    var nodes = document.querySelectorAll(
      '.razorpay-container, .razorpay-checkout-frame, iframe[src*="checkout.razorpay"], iframe[src*="api.razorpay.com"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var tag = (el.tagName || '').toLowerCase();
      if (tag === 'a' || tag === 'button') continue;
      if (
        el.closest &&
        el.closest(
          '.magic-checkout-btn, .rzp-magic-btn, .rzp-magic-btn__buy-product, #magic-checkout-data-container, magic-checkout-btn'
        )
      ) {
        continue;
      }
      var style = window.getComputedStyle(el);
      if (!style || style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
        continue;
      }
      var rect = el.getBoundingClientRect();
      if (rect.width < 240 || rect.height < 240) continue;
      return true;
    }
    return false;
  }

  function consumeCheckoutReturnFlag() {
    try {
      var raw = sessionStorage.getItem('arthcart_from_checkout');
      sessionStorage.removeItem('arthcart_from_checkout');
      if (!raw || raw === '1') return false;
      var ts = parseInt(raw, 10);
      if (!ts || Date.now() - ts > 30 * 60 * 1000) return false;
      return !pathLooksThankYou();
    } catch (e) {
      return false;
    }
  }

  function bindCheckoutReturnRecovery() {
    window.addEventListener('pageshow', function () {
      if (consumeCheckoutReturnFlag()) openCartDrawer();
    });

    var overlaySeenAt = 0;
    var cartWasOpenBeforeOverlay = false;
    var overlayObs = new MutationObserver(function () {
      var open = checkoutOverlayOpen();
      if (open) {
        if (!overlaySeenAt) {
          overlaySeenAt = Date.now();
          cartWasOpenBeforeOverlay = document.body.classList.contains('cart-sidebar-show');
        }
        return;
      }
      if (overlaySeenAt && Date.now() - overlaySeenAt >= 300) {
        overlaySeenAt = 0;
        var reopen = cartWasOpenBeforeOverlay;
        cartWasOpenBeforeOverlay = false;
        if (reopen && !pathLooksThankYou()) openCartDrawer();
        return;
      }
      overlaySeenAt = 0;
    });
    overlayObs.observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    var root = sidebar();
    if (!root) return;
    root.classList.add('arthcart-cart-drawer');

    if (!patchMobileQuickshop()) {
      var tries = 0;
      var patchTimer = setInterval(function () {
        if (patchMobileQuickshop() || ++tries > 40) clearInterval(patchTimer);
      }, 250);
    }

    var wasOpen = document.body.classList.contains('cart-sidebar-show');
    var bodyObs = new MutationObserver(function () {
      var isOpen = document.body.classList.contains('cart-sidebar-show');
      if (isOpen && !wasOpen) {
        startTimer();
        scheduleEnhance();
        if (pendingCelebrate) {
          pendingCelebrate = false;
          setTimeout(fireCartConfetti, 120);
        }
        var wrap = wrapEl();
        if (wrap && !wrap.querySelector('.previewCartItem, .previewCart-emptyBody, .previewCartInfo')) {
          refreshSidebarHtml(true);
        }
      } else if (!isOpen && wasOpen) {
        stopTimer();
      }
      wasOpen = isOpen;
    });
    bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    var wrap = wrapEl();
    if (wrap) {
      var wrapObs = new MutationObserver(function () {
        scheduleEnhance();
      });
      wrapObs.observe(wrap, { childList: true, subtree: false });
    }

    if (wasOpen) {
      startTimer();
      scheduleEnhance();
    }

    /* Task 90 — drawer close only (never item remove) */
    function isCloseCartTarget(t) {
      if (!t || !t.closest) return false;
      if (t.closest('[data-cart-remove], .previewCartItem-remove')) return false;
      var btn = t.closest('[data-close-cart-sidebar]');
      if (!btn) return false;
      /* Must be the drawer close, not a nested lookalike */
      return btn.classList.contains('halo-sidebar-close') || btn.hasAttribute('data-close-cart-sidebar');
    }

    function onCloseIntent(event) {
      if (!isCloseCartTarget(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      closeCartDrawer();
    }

    document.addEventListener('click', onCloseIntent, true);

    /* Task 92 — reliable per-item remove (attr, not jQuery .data) */
    var removeInFlight = false;
    function removeCartLine(btn) {
      if (!btn || removeInFlight) return;
      var line =
        btn.getAttribute('data-line') ||
        btn.getAttribute('data-cart-remove-id') ||
        '';
      if (!line) return;
      removeInFlight = true;
      btn.disabled = true;
      btn.style.opacity = '0.4';

      var body = 'quantity=0&id=' + encodeURIComponent(line);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        body: body,
        credentials: 'same-origin'
      })
        .then(function (res) {
          if (!res.ok) throw new Error('remove failed');
          return res.json();
        })
        .then(function (cart) {
          lastRefreshAt = 0;
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = String(cart.item_count || 0);
          });
          return refreshSidebarHtml(true).then(function () {
            scheduleEnhance();
            if (window.jQuery && window.halo && typeof halo.updateSidebarCart === 'function') {
              try {
                halo.updateSidebarCart(cart);
              } catch (e) {}
            }
          });
        })
        .catch(function () {
          /* Fallback to theme Shopify.removeItem */
          try {
            if (window.Shopify && typeof Shopify.removeItem === 'function') {
              Shopify.removeItem(line, function (cart) {
                lastRefreshAt = 0;
                refreshSidebarHtml(true);
                if (window.jQuery && window.halo && typeof halo.updateSidebarCart === 'function') {
                  halo.updateSidebarCart(cart);
                }
              });
            }
          } catch (e2) {}
        })
        .finally(function () {
          removeInFlight = false;
        });
    }

    document.addEventListener(
      'click',
      function (event) {
        var t = event.target;
        if (!t || !t.closest) return;

        var removeBtn = t.closest('#halo-cart-sidebar [data-cart-remove], #halo-cart-sidebar .previewCartItem-remove');
        if (removeBtn) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          removeCartLine(removeBtn);
          return;
        }

        if (
          document.body.classList.contains('cart-sidebar-show') &&
          t.classList &&
          t.classList.contains('background-overlay')
        ) {
          closeCartDrawer();
          return;
        }

        if (isCheckoutTrigger(t)) {
          markFromCheckout();
        }

        var cartLink = t.closest('a[href*="/cart"]');
        if (!cartLink) return;
        if (!isSameOriginCartPageLink(cartLink)) return;
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        openCartDrawer();
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && document.body.classList.contains('cart-sidebar-show')) {
        closeCartDrawer();
      }
    });

    var closeBtn = root.querySelector('.arthcart-cart-top > [data-close-cart-sidebar], .arthcart-cart-top > .halo-sidebar-close');
    if (closeBtn && !closeBtn.dataset.arthcartCloseBound) {
      closeBtn.dataset.arthcartCloseBound = '1';
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeCartDrawer();
      });
    }

    bindCheckoutReturnRecovery();
    consumeOpenCartIntent();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
